import * as yup from "yup";

import {
  chargeBearer,
  checkoutMethodsOrders,
  failedPaymentResolutionTypes,
  gateway_recommendation_type,
} from "../../enums";
import { ICheckoutAndPaymentLinkSettings } from "../../interfaces-and-types";

export const checkoutValidationSchema: yup.SchemaOf<ICheckoutAndPaymentLinkSettings> =
  yup
    .object({
      bearer: yup
        .mixed<chargeBearer>()
        .oneOf(Object.values(chargeBearer))
        .required("gateway recommendation type is required"),
      display_links_to_your_terms_and_policies: yup.boolean().required(),
      display_support_contact_info: yup.boolean().required(),
      include_payment_gateways_and_methods: yup.boolean().required(),
      checkout_methods_order: yup
        .mixed<checkoutMethodsOrders>()
        .oneOf(Object.values(checkoutMethodsOrders))
        .required("checkout methods order is required"),
      gateway_recommendation_type: yup
        .mixed<gateway_recommendation_type>()
        .oneOf(Object.values(gateway_recommendation_type))
        .required("Gateway recommendation type is required"),
      delayed_refund_duration_hours: yup.number().required(),
      instant_refund_incomplete_amount_threshold_percentage: yup
        .number()
        .required(),
      failed_payment_auto_resolution_type: yup
        .mixed<failedPaymentResolutionTypes>()
        .oneOf(Object.values(failedPaymentResolutionTypes))
        .required("Failed payment resolution type is required"),
    })
    .required();
